<template>
	<div class="section-how-it-work-slider" id="stepbystep">
		<div class="container">
			<v-layout row wrap justify-center>
				<v-flex xs12 md5 secondary--text class="section-how-it-work-slider-title">
					<h3>¿Cómo funciona</h3>
					<h2>CASAMARKET?</h2>
				</v-flex>
				<v-flex xs12 md5 info--text class="section-how-it-work-slider-subtext">
					<p>
						Añade a tu negocio una potente herramienta de tecnología.
						Te queremos mostrar lo sencillo que es usar CasaMarket
					</p>
				</v-flex>
			</v-layout>
			<div class="section-how-it-work-slider-steps">
				<v-layout>
					<v-flex 
						v-for="item in items" 
						:key="item.id">
						<button 
							class="container-step"
							:class="{ 'select' : item.number - 1 === sliderIndex}"
							@click="moveToIndex(item.number)">{{item.id}}</button>
					</v-flex>
				</v-layout>
				<hr class="section-how-it-work-slider-line">
			</div>
			<div class="container-sliders">
				<slider 
					animation="fade"
					:speed="2000"
					:stop-on-hover="true"
					:autoplay="false"
					:touch="false"
					height="100%"
					v-model="sliderIndex"
				>
					<slider-item v-for="item in items" :key="item.id">
						<v-layout wrap>
							<v-flex md6 xs12 class="order-2-mobile">
								<div class="slider-image-container">
									<div class="slider-number">{{ item.number}}</div>
									<div class="container-phones">
										<!-- <img 
											:src="item.gif" 
											:alt="item.title"
											class="step-image-gif"> -->
										<img
											:src="item.imageSecond"
											alt="tu cliente realiza el pedido"
											height="592"
											class="step-image-cel"
										/>	
									</div>
								</div>
							</v-flex>
							<v-flex md6 xs12 class="layout order-1-mobile">
								<v-layout wrap align-content-end>
									<v-flex xs12 mb-3 class="container-image">
										<img 
											:src="item.image" 
											:alt="item.title"
											height="150"
											class="container-desktop">
									</v-flex>
									<v-flex xs12>
										<div class="layout container-information">
											<div class="step-number">{{ item.id }}</div>
											<div class="container-text">
												<h3 class="slider-title">{{ item.title }}</h3>
												<template v-if="item.text">
													<p
														class="step-text info--text"
														:class="{ 'no-margin': item.list }"
													>
														{{ item.text }}
													</p>
												</template>
												<template v-if="item.list">
													<template v-for="(li, index) in item.list">
														<p
															:key="index"
															class="step-list info--text"
															:class="{ 'margin': li.list }"
														>
															- {{ li }}
														</p>
													</template>
												</template>
												<div class="mt-3 container-desktop">
													<v-btn
														class="btn-action btn-auto section-how-it-work-slider-btn white--text"
														color="primary"
														depressed
														@click="$emit('open-modal-btn')"
													>
														SOLICITA TU APP
													</v-btn>
												</div>
											</div>
										</div>
									</v-flex>
								</v-layout>
							</v-flex>
						</v-layout>
					</slider-item>
				</slider>
			</div>
		</div>
	</div>
</template>

<script>

function moveToIndex(index) {
	this.sliderIndex = index - 1;
}

function data() {
	return {
		items: [
			{
				id: 1,
				class: 'step-image-1',
				gif: 'https://media.giphy.com/media/ZBKbRBelpwg9LGlZAf/giphy.gif',
				image: '/static/images/sections/step-1.png',
				number: 1,
				position: true,
				text: 'A través de tu aplicativo tus clientes podrán hacer sus pedidos: así de fácil.',
				title: 'Tu cliente realiza el pedido',
				imageSecond: '/static/images/sections/how-1.png',
			},
			{
				id: 2,
				class: 'step-image-2',
				gif: 'https://media.giphy.com/media/PhBSL6TvxLb9dqiltL/giphy.gif',
				image: '/static/images/sections/step-2.png',
				list: ['Por entregar', 'Listo para entrega', 'Entregado'],
				number: 2,
				position: false,
				text: 'Recibe notificaciones cuando tengas un nuevo pedido. Gestiona y filtra por estados:',
				title: 'Recibes el pedido de inmediato',
				imageSecond: '/static/images/sliders/slide-2-CM.png',
			},
			{
				id: 3,
				class: 'step-image-3',
				gif: 'https://media.giphy.com/media/dsv0eAsC1naOjnc8Aj/giphy.gif',
				image: '/static/images/sections/step-3.png',
				list: [
					'Gestiona de una manera más ordenada los pedidos de tus clientes.',
					'Alista el pedido y déjalo para entregar según la modalidad que el cliente elija: Recojo en tienda o Delivery.',
				],
				number: 3,
				position: true,
				title: 'Preparas tu pedido',
				imageSecond: '/static/images/sections/how-3.png',
			},
			{
				id: 4,
				class: 'step-image-4',
				gif: 'https://media.giphy.com/media/SXIW01sfEu953X6FD6/giphy.gif',
				image: '/static/images/sections/step-4.png',
				number: 4,
				position: false,
				text: 'Entrega el pedido, y gestiónalo según el método de pago de tu preferencia. Cliente satisfecho.',
				title: 'Listo, confirmar para entrega',
				imageSecond: '/static/images/sections/how-4.png',
			},
		],
		sliderIndex: 0,
	};
}
export default {
	name: 'section-how-it-work-slider',
	data,
	methods: {
		moveToIndex,
	},
	props: {
		link: [String],
	},
};
</script>

<style lang="scss">
	.section-how-it-work-slider {
		padding: 90px 13%;
		font-size: size(medium16);
		text-align: center;

		&-title {
			line-height: 1;

			@media (min-width: 1024px) {
				border-right: 2px solid color(secondary);
				padding-right: 28px;
				text-align: right;
			}

			h3 {
				font-size: size(large30);
				font-weight: weight(w900);
				text-transform: uppercase;

				@media (max-width: 1024px) {
					font-size: size(large25);
				}
			}

			h2 {
				font-size: size(large47);
				font-weight: weight(w900);

				@media (max-width: 1024px) {
					font-size: size(large30);
				}
			}
		}

		&-subtext {
			p {
				font-size: size(medium18);
				line-height: 23px;
				margin: 47px auto 72px;
				max-width: 287px;

				@media (min-width: 1024px) {
					margin: 15px 0px 0px 38px;
					max-width: none;
					text-align: left;
				}
			}
		}

		&-steps {
			margin: 80px auto;
			position: relative;
			width: 70%;

			@media (max-width: 1024px) {
				display: none;
			}
		}

		&-line {
			border: 1px solid color(primary);
			left: 7%;
			position: absolute;
			top: 50%;
			width: 86%;
		}

		&-btn {
			border-radius: 8px;
			font-size: size(medium18);
			font-weight: weight(w600);
			height: 48px !important;
			width: 206px !important;
		}

		.container {
			&-step {
				align-items: center;
				background-color: color(white);
				border: 1px solid color(primary);
				border-radius: 50%;
				color: color(primary);
				display: flex;
				font-size: size(large37);
				font-weight: 600;
				justify-content: center;
				height: 98px;
				position: relative;
				margin: 0 auto;
				width: 98px;
				z-index: 1;

				&.select {
					border-color: color(primary-cs);
					background: color(primary-cs);
					color: color(white);
				}
			}

			&-sliders {
				height: 510px;
				min-height: 510px;

				@media (max-width: 1024px) {
					height: 800px;
				}
			}
		}

		.slider-image-container {
			padding: 0 10%;
			position: relative;

			@media (max-width: 1024px) {
				padding: 0;
			}
		}

		.slider-number {
			color: rgba(255, 110, 28, 0.1);
			display: initial;
			font-size: 400px;
			font-weight: 900;
			left: 12%;
			line-height: 1.3;
			position: absolute;
			z-index: 1;

			@media (max-width: 1024px) {
				display: none;
			}
		}

		.container-phones {
			margin-left: auto;
			position: relative;
			width: 284px;

			@media (max-width: 1024px) {
				margin: auto;
			}
		}

		.step-image-cel {
			height: 510px;
			width: 243px;
		}

		.step-image-gif {
			border-radius: 20px;
			left: 31px;
			position: absolute;
			top: 12px;
		}

		.slider-indicators-center {
			display: none;
		}

		.slider-btn {
			background: color(primary) !important;
			border-radius: 50%;
			height: 58px !important;
			top: 50% !important;
			width: 58px !important;

			@media (max-width: 1024px) {
				// bottom: 0 !important;
				top: auto !important;
			}

			&.slider-btn-right {
				@media (max-width: 1024px) {
					right: 10px !important;
				}
			}

			&.slider-btn-left {
				@media (max-width: 1024px) {
					left: 10px !important;
				}
			}
		}

		.slider-icon {
			border-left: 4px solid color(white) !important;
			border-bottom: 4px solid color(white) !important;
		}

		.step-number {
			color: color(primary);
			font-size: size(large77);
			font-weight: 600;
			line-height: 0.8;

			@media (max-width: 1024px) {
				font-size: size(large60);
			}
		}

		.container-text {
			padding: 0 25px;
			text-align: left;

			@media (max-width: 1024px) {
				padding: 0 0 0 10px;
				width: 100%;
			}
		}

		.container-information {
			padding: 0 80px 0 10px;

			@media (max-width: 1024px) {
				padding: 0 0 0 10px;
			}
		}

		.slider-title {
			border-bottom: 3px solid color(primary-cs);
			color: color(primary);
			font-size: size(large25);
			margin-bottom: 20px;

			@media (max-width: 1024px) {
				font-size: size(medium20);
			}
		}

		.container-image {
			padding: 0 80px 0 10px;

			@media (max-width: 1024px) {
				order: 1;
			}
		}

		.step-text {
			font-size: size(medium16);
			line-height: 1.7;
			margin-bottom: 65px;
			margin-top: 21px;
			text-align: left;

			&.no-margin {
				margin-bottom: 20px;
			}

			@media (max-width: 1024px) {
				margin-bottom: 45px;
				padding: 0 10px 0 0;
			}
		}

		.step-list {
			font-size: size(medium16);
			margin-bottom: 8px;
			text-align: left;

			&:last-of-type {
				&.margin {
					margin-bottom: 65px;
				}
			}

			@media (max-width: 1024px) {
				padding-right: 10px;
			}
		}

		@media (max-width: 1024px) {
			padding: 70px 0px;
		}

		.order-1-mobile {
			@media (max-width: 1024px) {
				order: 1;
			}
		}

		.order-2-mobile {
			@media (max-width: 1024px) {
				order: 2;
			}
		}

		.container-desktop {
			@media (max-width: 1024px) {
				display: none;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/home/section-how-it-work-slider.vue